<!-- carrinho -->
<div class="w-full">
  <!-- <div class="flex-col">
    <p class="font-semibold text-xs text-pink-800 text-center py-2 lg:text-[.75rem]">QUANTIDADE</p>
    <input type="number" value="1" (change)="clientMarketplaceCartProductQuantityChange($event)" class="focus:outline-none border-2 border-gray-200 rounded-lg w-24 h-16 text-center font-semibold text-xl" />
  </div> -->
  <div class="w-full lg:w-1/2">
    <ng-container *ngIf="product.inventory_quantity_available > 0 && product.product_status == 'active' && !messageProcess">
      <button title="Comprar" class="bg-[#FFBE0B] rounded-lg space-x-2 w-full p-2 hover:bg-amber-500" (click)="openAddToCartModal(product)">
        <p class="text-black font-semibold text-sm lg:text-base">Comprar</p>
      </button>
    </ng-container>
    <ng-container *ngIf="messageProcess">
      <button title="Carregando" class="bg-pink-800 rounded-lg space-x-2 w-full flex items-center justify-center p-2 max-h-10">
        <p-progressSpinner [style]="{ width: '18px'}" styleClass="custom-spinner" strokeWidth="8" fill="transparent" animationDuration=".8s"></p-progressSpinner>
        <p class="text-white text-center text-sm lg:text-base lg:font-medium pb-1">Carregando</p>
      </button>
    </ng-container>
    <ng-container *ngIf="product.inventory_quantity_available < 1 || product.product_status == 'inactive'">
      <button (click)="clientMarketplaceNoticeProductServiceCreate(product.id)" class="bg-gray-200 rounded-lg text-gray-800 space-x-2 w-full h-10 p-2 hover:bg-gray-400">
        <p class="text-xs font-semibold text-center lg:text-sm lg:leading-4">Avise-me quando disponível</p>
      </button>
    </ng-container>
  </div>
</div>

<p-dialog header="Resumo" [(visible)]="addToCartModal" [modal]="true" [baseZIndex]="10000" [draggable]="false" [closable]="true" [breakpoints]="{'960px': '60vw', '670px': '90vw'}">
  <ng-container *ngIf="productAddedToCart?.id">
    <div class="flex flex-col space-y-6 justify-center p-2">
      <div class="flex items-start space-x-2">
        <div id="tabs-2-panel-1" aria-labelledby="tabs-2-tab-1" role="tabpanel" tabindex="0">
          <ng-container *ngIf="product.img_spotlight !== null">
            <img src="{{product.img_spotlight}}" alt="{{product.name}}" class="h-36 object-cover object-center" />
          </ng-container>
          <ng-container *ngIf="product.img_spotlight == null">
            <img src="/assets/images/no_imagem.png" alt="{{product.name}}" class="h-36 object-contain object-center" />
          </ng-container>
        </div>

        <div class="flex flex-col space-y-3">
          <p class="text-gray-800 font-medium">{{product.name}}</p>

          <ng-container *ngIf="product.inventory_quantity > 0 && product.product_status == 'active'">
            <div class="mt-2 flex items-center justify-center">
              <button (click)="clientMarketplaceCartProductQuantityMinus()" (change)="clientMarketplaceCartProductQuantityChange($event)" class="bg-gray-100 rounded-full px-2 cursor-pointer hover:bg-gray-300"><span class="text-center text-lg text-gray-800 font-bold lg:text-xl">-</span></button>
              <input aria-label="Quantidade" type="number" (change)="clientMarketplaceCartProductQuantityChange($event)" class="w-full text-center border-transparent text-lg text-gray-800 font-bold lg:text-xl" value="{{inventoryQuantity}}" />
              <button (click)="clientMarketplaceCartProductQuantityPlus()" (change)="clientMarketplaceCartProductQuantityChange($event)" class="bg-gray-100 rounded-full px-2 cursor-pointer hover:bg-gray-300"><span class="text-lg text-gray-800 font-bold lg:text-xl">+</span></button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="flex justify-between items-center bg-gray-100 p-4">
      <div class="flex flex-col space-y-1">
        <p class="text-gray-700 text-sm font-medium">Produto</p>
        <p class="text-pink-800 text-sm font-medium">R$ {{product.price | number:'1.2-2'}}</p>
      </div>
      <div class="flex flex-col space-y-1">
        <p class="text-gray-700 text-sm font-medium">Subtotal</p>
        <p class="text-pink-800 text-sm font-medium">R$ {{product.price * inventoryQuantity | number:'1.2-2'}}</p>
      </div>
    </div>
    <div class="mt-5 flex justify-end gap-3">
      <button (click)="clientMarketplaceCartProductServiceCreate()" type="button" class="flex-1 rounded-lg bg-pink-800 px-4 py-2 text-center text-sm font-medium text-white shadow-sm transition-all hover:bg-pink-900 focus:ring focus:ring-gray-100 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-400">
        Continuar
      </button>
    </div>
  </ng-container>
</p-dialog>

<p-dialog [(visible)]="displayModal" [modal]="true" [baseZIndex]="10000" [draggable]="false" [closable]="true" [breakpoints]="{'960px': '35vw', '670px': '90vw'}">
  <ng-container *ngIf="productAddedToCart?.id">
    <div class="relative p-5">
      <div class="flex flex-col items-center justify-center">
        <div class="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 lg:h-8 lg:w-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="text-center">
          <h3 class="text-lg font-semibold text-secondary-900">Produto Adicionado ao Carrinho</h3>
          <div class="mt-2 text-sm text-secondary-500">{{inventoryQuantity}} x {{product.name}}</div>
        </div>
      </div>
      <div class="mt-5 flex justify-end gap-3">
        <button
          [routerLink]="['/p/checkout']"
          [queryParams]="{uid: cart.client_marketplace_cart_uid, one_click_buy: true}"
          type="button"
          class="flex-1 rounded-lg border border-pink-800 bg-white px-4 py-2 text-center text-sm font-medium text-pink-800 shadow-sm transition-all hover:bg-gray-100 focus:ring focus:ring-gray-100 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-400"
        >
          Finalizar Compra
        </button>
        <button
          [routerLink]="['/p/cart']"
          [queryParams]="{uid: cart.client_marketplace_cart_uid}"
          type="button"
          class="flex-1 rounded-lg border border-pink-800 bg-pink-800 px-4 py-2 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-pink-900 hover:bg-pink-900 focus:ring focus:ring-pink-900 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-500"
        >
          Carrinho
        </button>
      </div>
    </div>
  </ng-container>
</p-dialog>
